const EXPERIMENTS = {
  USE_FIELDS_V2: "specs.forms.UseFieldsV2",
  ENABLE_SUBMIT_LIMITS_SETTINGS: "specs.forms.EnableSubmitLimitsSettings",
  ENABLE_READ_ONLY_SETTING: "specs.forms.EnableReadOnlySetting",
  ENABLE_DEFAULT_VALUE_SETTING: "specs.forms.EnableDefaultValueSetting",
  ENABLE_FLOATING_ACTION_TOOLBAR: "specs.forms.EnableFieldActionToolbar",
  ENABLE_FIELD_ACTION_TOOLBAR_WIXEL: "specs.forms.EnableFieldActionToolbarWixel",
  REMOVE_FALSY_VALUES: "specs.forms.RemoveFalsyValues",
  BIF_ON_MEETINGS: "specs.bookings.BIFonMeetings",
  INFORM_MEETINGS_USERS: "specs.bookings.InformMeetingsUsers",
  BIF_ON_MEETINGS_CHANGE: "specs.bookings.BifOnMeetingsInstallOnlyMeetings",
  SCHEDULING_INSTALL_MODE: "specs.bookings.BifOnMeetingsInstallMode",
  DATE_PICKER_ADVANCED_SETTINGS: "specs.forms.DatePickerAdvancedSettings",
  ENABLE_HEADING_LEVELS: "specs.forms.EnableHeadingLevels",
  ENABLE_SUBSCRIBE_CHANNELS_SETTINGS: "specs.forms.EnableSubscribeChannelsSettings",
  SUBMIT_SUCCESS_NO_FOCUS: "specs.forms.SubmitSuccessNoFocus",
  ENABLE_ROUND_ROBIN_IN_BIF: "specs.forms.EnableRoundRobinInBIF",
  ENABLE_3D_FILE_UPLOAD: "specs.forms.Enable3DFileUpload",
  OPTIONS_BULK_EDIT_UNDER_ADD_BUTTON: "specs.forms.OptionsBulkEditUnderAddOptionButton"
};
export {
  EXPERIMENTS
};
//# sourceMappingURL=experiments.js.map
